{
  "about.contact": "კონტაქტი:",
  "about.domain_blocks.no_reason_available": "მიზეზი მიუწვდომელია",
  "account.add_or_remove_from_list": "სიებში დამატება ან წაშლა",
  "account.badges.bot": "ბოტი",
  "account.badges.group": "ჯგუფი",
  "account.block": "დაბლოკე @{name}",
  "account.block_domain": "დაიმალოს ყველაფერი დომენიდან {domain}",
  "account.blocked": "დაბლოკილია",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.edit_profile": "პროფილის ცვლილება",
  "account.endorse": "გამორჩევა პროფილზე",
  "account.follow": "გაყოლა",
  "account.followers": "მიმდევრები",
  "account.hide_reblogs": "დაიმალოს ბუსტები @{name}-სგან",
  "account.media": "მედია",
  "account.mention": "ასახელეთ @{name}",
  "account.mute": "გააჩუმე @{name}",
  "account.muted": "დადუმებულია",
  "account.posts": "პოსტები",
  "account.report": "დაარეპორტე @{name}",
  "account.share": "გააზიარე @{name}-ის პროფილი",
  "account.show_reblogs": "აჩვენე ბუსტები @{name}-სგან",
  "account.unblock": "განბლოკე @{name}",
  "account.unblock_domain": "გამოაჩინე {domain}",
  "account.unendorse": "არ გამოირჩეს პროფილზე",
  "account.unfollow": "ნუღარ მიჰყვები",
  "account.unmute": "ნუღარ აჩუმებ @{name}-ს",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.retention.cohort_size": "ახალი მომხმარებელი",
  "alert.unexpected.message": "წარმოიშვა მოულოდნელი შეცდომა.",
  "alert.unexpected.title": "უპს!",
  "boost_modal.combo": "შეგიძლიათ დააჭიროთ {combo}-ს რათა შემდეგ ჯერზე გამოტოვოთ ეს",
  "bundle_column_error.retry": "სცადეთ კიდევ ერთხელ",
  "bundle_modal_error.close": "დახურვა",
  "bundle_modal_error.retry": "სცადეთ კიდევ ერთხელ",
  "column.blocks": "დაბლოკილი მომხმარებლები",
  "column.community": "ლოკალური თაიმლაინი",
  "column.domain_blocks": "დამალული დომენები",
  "column.follow_requests": "დადევნების მოთხოვნები",
  "column.home": "საწყისი",
  "column.lists": "სიები",
  "column.mutes": "გაჩუმებული მომხმარებლები",
  "column.notifications": "შეტყობინებები",
  "column.pins": "აპინული ტუტები",
  "column.public": "ფედერალური თაიმლაინი",
  "column_back_button.label": "უკან",
  "column_header.hide_settings": "პარამეტრების დამალვა",
  "column_header.moveLeft_settings": "სვეტის მარცხნივ გადატანა",
  "column_header.moveRight_settings": "სვეტის მარჯვნივ გადატანა",
  "column_header.pin": "მიმაგრება",
  "column_header.show_settings": "პარამეტრების ჩვენება",
  "column_header.unpin": "მოხსნა",
  "community.column_settings.media_only": "მხოლოდ მედია",
  "compose_form.direct_message_warning_learn_more": "გაიგე მეტი",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "თქვენი ანგარიში არაა {locked}. ნებისმიერს შეიძლია გამოგყვეთ, რომ იხილოს თქვენი მიმდევრებზე გათვლილი პოსტები.",
  "compose_form.lock_disclaimer.lock": "ჩაკეტილი",
  "compose_form.placeholder": "რაზე ფიქრობ?",
  "compose_form.spoiler.marked": "გაფრთხილების უკან ტექსტი დამალულია",
  "compose_form.spoiler.unmarked": "ტექსტი არაა დამალული",
  "confirmation_modal.cancel": "გაუქმება",
  "confirmations.block.confirm": "ბლოკი",
  "confirmations.delete.confirm": "წაშლა",
  "confirmations.delete.message": "დარწმუნებული ხართ, გსურთ გააუქმოთ ეს სტატუსი?",
  "confirmations.delete_list.confirm": "წაშლა",
  "confirmations.delete_list.message": "დარწმუნებული ხართ, გსურთ სამუდამოდ გააუქმოთ ეს სია?",
  "confirmations.mute.confirm": "დადუმება",
  "confirmations.redraft.confirm": "გაუქმება და გადანაწილება",
  "confirmations.unfollow.confirm": "ნუღარ მიჰყვები",
  "embed.instructions": "ეს სტატუსი ჩასვით თქვენს ვებ-საიტზე შემდეგი კოდის კოპირებით.",
  "embed.preview": "ესაა თუ როგორც გამოჩნდება:",
  "emoji_button.activity": "აქტივობა",
  "emoji_button.custom": "მომხმარებლის",
  "emoji_button.flags": "ალმები",
  "emoji_button.food": "საჭმელი და სასლმელი",
  "emoji_button.label": "ემოჯის ჩასმა",
  "emoji_button.nature": "ბუმება",
  "emoji_button.not_found": "არაა ემოჯი!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "ობიექტები",
  "emoji_button.people": "ხალხი",
  "emoji_button.recent": "ხშირად გამოყენებული",
  "emoji_button.search": "ძებნა...",
  "emoji_button.search_results": "ძებნის შედეგები",
  "emoji_button.symbols": "სიმბოლოები",
  "emoji_button.travel": "მოგზაურობა და ადგილები",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.community": "ლოკალური თაიმლაინი ცარიელია. დაწერეთ რაიმე ღიად ან ქენით რაიმე სხვა!",
  "empty_column.domain_blocks": "There are no hidden domains yet.",
  "empty_column.hashtag": "ამ ჰეშტეგში ჯერ არაფერია.",
  "empty_column.home": "თქვენი სახლის თაიმლაინი ცარიელია! ესტუმრეთ {public}-ს ან დასაწყისისთვის გამოიყენეთ ძებნა, რომ შეხვდეთ სხვა მომხმარებლებს.",
  "empty_column.list": "ამ სიაში ჯერ არაფერია. როდესაც სიის წევრები დაპოსტავენ ახალ სტატუსებს, ისინი გამოჩნდებიან აქ.",
  "empty_column.notifications": "ჯერ შეტყობინებები არ გაქვთ. საუბრის დასაწყებად იურთიერთქმედეთ სხვებთან.",
  "empty_column.public": "აქ არაფერია! შესავსებად, დაწერეთ რაიმე ღიად ან ხელით გაჰყევით მომხმარებლებს სხვა ინსტანციებისგან",
  "follow_request.authorize": "ავტორიზაცია",
  "follow_request.reject": "უარყოფა",
  "getting_started.heading": "დაწყება",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "home.column_settings.show_reblogs": "ბუსტების ჩვენება",
  "home.column_settings.show_replies": "პასუხების ჩვენება",
  "keyboard_shortcuts.back": "უკან გადასასვლელად",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "დასაბუსტად",
  "keyboard_shortcuts.column": "ერთ-ერთი სვეტში სტატუსზე ფოკუსირებისთვის",
  "keyboard_shortcuts.compose": "შედგენის ტექსტ-არეაზე ფოკუსირებისთვის",
  "keyboard_shortcuts.description": "აღწერილობა",
  "keyboard_shortcuts.down": "სიაში ქვემოთ გადასაადგილებლად",
  "keyboard_shortcuts.enter": "სტატუსის გასახსნელად",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "კლავიატურის სწრაფი ბმულები",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "მალსახმობი ღილაკი",
  "keyboard_shortcuts.legend": "ამ ლეგენდის გამოსაჩენად",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "ავტორის დასახელებლად",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "ავტორის პროფილის გასახსნელად",
  "keyboard_shortcuts.reply": "პასუხისთვის",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "ძიებაზე ფოკუსირებისთვის",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "გაფრთხილების უკან ტექსტის გამოსაჩენად/დასამალვად",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "ახალი ტუტის დასაწყებად",
  "keyboard_shortcuts.unfocus": "შედგენის ტექსტ-არეაზე ფოკუსის მოსაშორებლად",
  "keyboard_shortcuts.up": "სიაში ზემოთ გადასაადგილებლად",
  "lightbox.close": "დახურვა",
  "lightbox.next": "შემდეგი",
  "lightbox.previous": "წინა",
  "lists.delete": "სიის წაშლა",
  "lists.edit": "სიის შეცვლა",
  "navigation_bar.blocks": "დაბლოკილი მომხმარებლები",
  "navigation_bar.domain_blocks": "დამალული დომენები",
  "navigation_bar.filters": "გაჩუმებული სიტყვები",
  "navigation_bar.follow_requests": "დადევნების მოთხოვნები",
  "navigation_bar.lists": "სიები",
  "navigation_bar.logout": "გასვლა",
  "navigation_bar.mutes": "გაჩუმებული მომხმარებლები",
  "navigation_bar.preferences": "პრეფერენსიები",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} გამოგყვათ",
  "notification.reblog": "{name}-მა დაბუსტა თქვენი სტატუსი",
  "notifications.clear": "შეტყობინებების გასუფთავება",
  "notifications.clear_confirmation": "დარწმუნებული ხართ, გსურთ სამუდამოდ წაშალოთ ყველა თქვენი შეტყობინება?",
  "notifications.column_settings.alert": "დესკტოპ შეტყობინებები",
  "notifications.column_settings.follow": "ახალი მიმდევრები:",
  "notifications.column_settings.mention": "ხსენებები:",
  "notifications.column_settings.push": "ფუშ შეტყობინებები",
  "notifications.column_settings.reblog": "ბუსტები:",
  "notifications.column_settings.show": "გამოჩნდეს სვეტში",
  "notifications.column_settings.sound": "ხმის დაკვრა",
  "notifications.column_settings.status": "New toots:",
  "notifications.group": "{count} შეტყობინება",
  "privacy.change": "სტატუსის კონფიდენციალურობის მითითება",
  "privacy.public.short": "საჯარო",
  "relative_time.days": "{number}დღ",
  "relative_time.hours": "{number}სთ",
  "relative_time.just_now": "ახლა",
  "relative_time.minutes": "{number}წთ",
  "relative_time.seconds": "{number}წმ",
  "reply_indicator.cancel": "გაუქმება",
  "report.forward": "ფორვარდი {target}-ს",
  "report.forward_hint": "ანგარიში სხვა სერვერიდანაა. გავაგზავნოთ რეპორტის ანონიმური ასლიც?",
  "report.placeholder": "დამატებითი კომენტარები",
  "report.submit": "გადაცემა",
  "report.target": "არეპორტებთ {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "ძებნა",
  "search_results.hashtags": "ჰეშტეგები",
  "search_results.statuses": "პოსტები",
  "sign_in_banner.sign_in": "შესვლა",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "დაბლოკე @{name}",
  "status.cancel_reblog_private": "ბუსტის მოხსნა",
  "status.cannot_reblog": "ეს პოსტი ვერ დაიბუსტება",
  "status.copy": "Copy link to status",
  "status.delete": "წაშლა",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "მეტის ჩატვირთვა",
  "status.media_hidden": "მედია დამალულია",
  "status.mention": "ასახელე @{name}",
  "status.more": "მეტი",
  "status.mute": "გააჩუმე @{name}",
  "status.mute_conversation": "გააჩუმე საუბარი",
  "status.open": "ამ სტატუსის გაფართოება",
  "status.pin": "აპინე პროფილზე",
  "status.reblog": "ბუსტი",
  "status.reblogged_by": "{name} დაიბუსტა",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.redraft": "გაუქმდეს და გადანაწილდეს",
  "status.reply": "პასუხი",
  "status.replyAll": "უპასუხე თემას",
  "status.report": "დაარეპორტე @{name}",
  "status.sensitive_warning": "მგრძნობიარე კონტენტი",
  "status.share": "გაზიარება",
  "status.show_less_all": "აჩვენე ნაკლები ყველაზე",
  "status.show_more_all": "აჩვენე მეტი ყველაზე",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "საუბარზე გაჩუმების მოშორება",
  "status.unpin": "პროფილიდან პინის მოშორება",
  "tabs_bar.home": "საწყისი",
  "tabs_bar.notifications": "შეტყობინებები",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "ui.beforeunload": "თქვენი დრაფტი გაუქმდება თუ დატოვებთ მასტოდონს.",
  "upload_area.title": "გადმოწიეთ და ჩააგდეთ ასატვირთათ",
  "upload_button.label": "მედიის დამატება",
  "upload_progress.label": "იტვირთება...",
  "video.close": "ვიდეოს დახურვა",
  "video.exit_fullscreen": "სრულ ეკრანზე ჩვენების გათიშვა",
  "video.expand": "ვიდეოს გაფართოება",
  "video.fullscreen": "ჩვენება სრულ ეკრანზე",
  "video.hide": "ვიდეოს დამალვა",
  "video.pause": "პაუზა",
  "video.play": "დაკვრა"
}
